import React, { useState } from "react";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import OutsideClickHandler from "react-outside-click-handler";
import { Link } from "react-router-dom";
import mainLogo from "../../images/logo/logo_new.png";
import { IMAGE_URL } from "../../settings/config";
import FoodSuggestionInput from "./FoodSuggestionInput";
import SuggestionInput from "./suggestionInput";
function getLatLngFromLocalStorage() {
  return localStorage.getItem("latlng") ? localStorage.getItem("latlng") : "";
}
const Header = ({
  user,
  logout,
  home,
  suggestionBar,
  foodSuggestionsBar,
  cart,
  partnar,
  loginHeader
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  // console.log(loginHeader);
  let cartItemsQuantity = cart?.reduce((total, cartItem) => {
    return (total += parseFloat(cartItem.quantity));
  }, 0);

  const handleButton = (event) => {
    event.preventDefault();
    setIsOpen(!isOpen);
  };

  console.log({ user });

  return (
    <header
      className={(home && "absolute top-0 left-0 w-full z-20") || "w-full z-20 shadow-[0px_0px_12px_rgba(46,49,146,0.08)]"}
    >
      <div className="container mx-auto">
        <div className="flex justify-between items-center py-5">
          <div className="drawer-menu md:hidden">
            <div className="toggle-button mt-2">
              <button type="button" id="menuButton">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 stroke-black text-black"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h8m-8 6h16"
                  />
                </svg>
              </button>
            </div>
          </div>
          <div id="overlay"></div>
          <div id="side-menu" className="main-side-nav">
            <a href="#0" id="close-menu" className="menuCloseButton">
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 stroke-current text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </span>
            </a>
            <ul className="mainMenu nav">
              <li className="active">
                <a href="#0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-3"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                    />
                  </svg>
                  <span>Home</span>
                </a>
              </li>
              <li>
                <a href="#0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-3"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <span>Help</span>
                </a>
              </li>
              <li>
                <a href="#0">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5 mr-3"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
                    />
                  </svg>
                  <span>Contact us</span>
                </a>
              </li>
            </ul>
          </div>
          <div className="header-logo">
            <Link to={"/"}>
              <img className="h-12" src={mainLogo} alt="BMP Logo" />
            </Link>
          </div>

          {suggestionBar ? <SuggestionInput /> : ""}
          {foodSuggestionsBar ? <FoodSuggestionInput /> : ""}

          <div className="header-item md:block hidden">
            <ul className="m-0 p-0 flex items-center gap-5 text-white">
              {user?.id ? (
                <div className="border border-[#0DC1D9] ml-2 w-24 rounded-md flex items-center justify-center">
                  <Link
                    to="/wishlist"
                    className="relative flex justify-center items-center"
                  >
                    <p className="text-black mr-1 py-2">Wishlist</p>
                    <div>
                      {/* {  wishlist?.length ? 
           <i className="fa-solid fa-heart fa-lg" style={{color:'#ffd43b'}}></i>
            
              : */}

                      <svg
                        className="w-6 h-6 flex-1"
                        width="20"
                        height="15"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0.994141 2.97514C1.04438 2.74252 1.07817 2.50575 1.14759 2.27729C1.57506 0.863304 2.98899 -0.0596894 4.59838 0.00926511C5.68167 0.0557886 6.59414 0.461208 7.40798 1.08512C7.43355 1.10506 7.45913 1.125 7.49201 1.14992C7.60344 1.06851 7.71213 0.984597 7.8254 0.905673C8.49308 0.4421 9.2311 0.134712 10.0714 0.0300345C11.9046 -0.19926 13.5852 0.907335 13.9232 2.56307C14.1333 3.59074 13.8629 4.52288 13.2957 5.4035C12.7997 6.17446 12.1558 6.83576 11.4452 7.44555C10.3281 8.4026 9.08679 9.20679 7.7715 9.92209C7.58517 10.0234 7.41437 10.0276 7.2253 9.92459C5.70907 9.09962 4.286 8.16417 3.05567 7.00274C2.335 6.324 1.70659 5.58295 1.312 4.69817C1.16038 4.35838 1.05442 4.00696 1.01515 3.64059C1.01332 3.61816 1.00145 3.59739 0.994141 3.57579C0.994141 3.37557 0.994141 3.17536 0.994141 2.97514ZM4.47416 0.746164C3.3717 0.721241 2.38524 1.32605 2.00435 2.26649C1.68101 3.06569 1.76504 3.84413 2.15689 4.60595C2.54965 5.36944 3.12234 6.01329 3.7672 6.60729C4.85596 7.61004 6.09634 8.435 7.41437 9.16775C7.48013 9.2043 7.52398 9.19683 7.58426 9.16276C8.5826 8.60864 9.53526 7.99718 10.4158 7.29601C11.2506 6.63139 12.0179 5.91277 12.5851 5.0363C13.0409 4.3318 13.3048 3.58576 13.1331 2.75581C12.9431 1.83697 12.3933 1.18066 11.4031 0.874104C10.5975 0.62404 9.8175 0.743672 9.06669 1.071C8.5963 1.2762 8.18801 1.55949 7.819 1.89264C7.60618 2.08455 7.38971 2.08288 7.17415 1.89513C7.09194 1.82285 7.01065 1.74974 6.92388 1.68245C6.21874 1.12998 5.42592 0.766934 4.47416 0.746164Z"
                          fill="#0DC1D9
"
                        />
                      </svg>
                      {/* }
                       */}
                    </div>
                  </Link>
                </div>
              ) : null}

              {partnar ? (
                <OutsideClickHandler
                  onOutsideClick={() => {
                    setIsOpen(false);
                  }}
                >
                  <li>
                    <div className="flex justify-center bg-gray-100 rounded-md">
                      <div>
                        <div
                          // @click.away="$refs.dropdown.removeAttribute('open');"
                          className="relative inline-block text-left"
                        >
                          <div className="list-none">
                            <div
                              onClick={handleButton}
                              className="
                            flex items-center justify-center w-full rounded-md border border-[#0DC1D9] px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500
                             cursor-pointer
                          "
                            >
                              Partner With Us
                           
                              {/* <svg xmlns="http://www.w3.org/2000/svg" width="17" height="8" fill="none"
                              //  xmlns:v="https://vecta.io/nano"
                               ><path d="M8.468 7.848L.847.148h15.242l-7.621 7.7z" fill="#0dc1d9"/></svg> */}
                             { isOpen ?
                              <IoMdArrowDropup className="text-[#0DC1D9] text-lg "/>
                              :
                              <IoMdArrowDropdown className="text-[#0DC1D9] text-lg "/>
                               }
                            </div>
                          </div>

                          {isOpen ? (
                            <div
                              role="menu"
                              className="z-10 origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                              style={{ zIndex: "999" }}
                            >
                              <div className="py-1" role="none">
                                <div className="flex items-center px-2 py-2 hover:bg-[#0292EE1A] ">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="16"
                                    fill="none"
                                    // xmlnsV="https://vecta.io/nano"
                                  >
                                    <path
                                      d="M1.462 9.66h-1.1c-.23 0-.365-.118-.361-.307s.134-.294.354-.295h1.11v-.605H.938C.721 8.45.589 8.334.59 8.15s.131-.299.35-.302h1.364c.217 0 .349.119.348.302s-.134.296-.351.302h-.228v.605h.521c.218.003.35.115.352.298s-.131.302-.345.305h-.527c.034.202.154.298.33.299h3.153c.045.001.09-.007.132-.024a.33.33 0 0 0 .112-.076.34.34 0 0 0 .073-.115c.016-.043.024-.089.023-.135V7.29c0-.193-.141-.328-.33-.341-.129-.009-.258-.003-.387-.003h-.165v.819c0 .287-.099.388-.374.389H3.333c-.287 0-.38-.101-.381-.4v-.807c-.2 0-.385-.018-.565.007-.092.012-.189.084-.26.154-.148.147-.305.18-.439.068s-.142-.291-.02-.454a.9.9 0 0 1 .319-.281c.127-.066.267-.1.409-.1l3.171.008c.219.005.436.129.668.202.357-.989.869-1.904 2.012-2.258-.42-.369-.69-.807-.812-1.338-.3-1.305.552-2.648 1.847-2.91 1.311-.265 2.588.65 2.782 1.994.018.124.046.252.025.374a.47.47 0 0 1-.162.269c-.075.056-.122.098-.093.189.058.183.079.4.19.541.264.336.125.67-.088.893a.99.99 0 0 0-.202.315c-.156.396-.434.626-.915.689l.746.857c.226.221.542.211.824.162.493-.083.916-.004 1.264.418l.081-.173c.253-.495.655-.771 1.194-.833.288-.033.412.088.413.384v2.245c0 .292-.132.414-.417.377-.138-.018-.274-.057-.428-.092l.047.139.928 2.218c.045.109.092.162.222.165 1.343.031 2.365 1.169 2.302 2.556a2.39 2.39 0 0 1-2.513 2.264c-1.107-.072-1.968-.893-2.185-2.094H8.836c-.114.689-.439 1.253-1.009 1.656a2.29 2.29 0 0 1-1.389.422c-.951-.013-2.044-.681-2.291-2.093h-.82c-.275 0-.375-.108-.372-.392a5.59 5.59 0 0 1 .577-2.432 2.01 2.01 0 0 1 .145-.24c.053-.077.113-.148.185-.24l-.142-.016H2.557c-.639-.002-.954-.26-1.095-.907zm7.677 3.613c-.308-.417-.3-.882-.289-1.348v-.434c0-.573-.345-.925-.909-.925-.841 0-1.683.011-2.524-.003-.686-.012-1.157.289-1.438.928-.252.561-.401 1.166-.438 1.782h5.597zm.37-6.009l-.333-.507c-.021-.033-.036-.07-.043-.109s-.006-.079.003-.117.025-.075.048-.107.052-.059.085-.079c.139-.089.299-.05.402.101.029.041.049.087.076.129.332.543.84.951 1.435 1.151.071.022.143.039.216.053l.222-.913c-.432-.141-.732-.485-1-.868l-.35-.485c-.226-.292-.503-.511-.863-.61-.827-.229-1.582.062-2.103.82-.337.49-.538 1.042-.665 1.622l-.186 1.1h2.458l.6-1.181zm3.213 6.018l.856-.005c.085-.009.164-.052.218-.12l1.117-1.59c.073-.101.071-.181.025-.289l-1.263-3.007a1.04 1.04 0 0 0-.049-.101l-1.439.338.03.158.732 3.245c.053.255.028.536-.01.798-.027.192-.136.371-.216.574h-.001zM11.464 2.114C11.39 1.25 10.508.54 9.619.609c-.97.075-1.727.972-1.651 1.954.065.82.825 1.655 1.471 1.604v-.789c.006-.724.529-1.258 1.238-1.264h.787 0zm-.852 9.952l-.007-1.707c-.037-.622-.384-1.032-.966-1.215-.176-.054-.358-.083-.542-.085l-2.45-.004-.144.007-.039.898h1.55a1.39 1.39 0 0 1 .548.109c.174.073.332.181.464.317s.238.298.309.475a1.48 1.48 0 0 1 .106.561v.643l1.172-.001zm-1.07-3.589l.136.05c.932.223 1.533.995 1.533 1.966l.003 1.47c0 .06.038.159.08.174.428.148.676.454.788.935a1.93 1.93 0 0 0 .187-.235c.132-.238.168-.519.101-.784l-.727-3.266c-.054-.255-.134-.416-.418-.425a.93.93 0 0 1-.367-.116l-.936-.492-.381.723zm5.396 4.089l.024.024.158-.089c.443-.202.866-.169 1.248.138a1.15 1.15 0 0 1 .428 1.172c-.046.259-.174.495-.365.672s-.433.285-.689.306c-.512.047-.992-.26-1.202-.759-.024-.057-.085-.13-.135-.135-.166-.011-.332-.013-.498-.007-.002.024-.002.048 0 .072.16.889 1.062 1.553 1.934 1.426.974-.143 1.659-1.011 1.558-1.974s-.929-1.701-1.823-1.634c-.052.005-.101.03-.135.07l-.504.715v.002zm-6.719 1.322c-.173 0-.333-.007-.493.005-.027.005-.052.016-.074.033s-.04.038-.053.063c-.208.504-.579.785-1.109.786s-.902-.28-1.11-.784c-.01-.023-.024-.044-.043-.061s-.041-.029-.064-.036c-.169-.011-.34-.005-.511-.005.078.819.868 1.504 1.717 1.508.861.002 1.649-.67 1.741-1.511v.003zm2.935-11.164c-.166 0-.374-.015-.58.004-.146.015-.281.083-.381.192a.62.62 0 0 0-.161.402v1.091c0 .045.033.12.065.13a3.18 3.18 0 0 0 .569.142c.348.039.488-.101.549-.454.017-.101.099-.19.161-.273a.59.59 0 0 1 .135-.109l-.357-1.128v.003zm-1.637 9.957a.85.85 0 0 0 .302.435.82.82 0 0 0 .496.166h.975a1.86 1.86 0 0 0 .208-.023c-.017-.337-.219-.568-.513-.574l-1.468-.007v.003zm3.85-5.129c-.19-.575-.457-.756-.866-.609-.341.123-.555.564-.433.907.451.016.898-.088 1.298-.3v.003zm1.375-1.128c-.336.087-.58.439-.58.824s.246.739.58.822V6.424zm.408 7.461c.162.261.409.353.664.272.127-.039.238-.122.313-.234a.61.61 0 0 0-.047-.741.59.59 0 0 0-.33-.192c-.115-.026-.236-.011-.342.042s-.192.141-.243.249h.443c.197.006.328.13.324.306s-.128.289-.317.295l-.465.002zM3.548 7.534h.86v-.581h-.862l.002.581zm3.432 6.363h-.985c.128.194.289.281.486.283.101.004.201-.02.289-.07s.161-.124.21-.214h.001z"
                                      fill="#0dc1d9"
                                    />
                                  </svg>
                                  <Link
                                    to={"/driver/registration"}
                                    className="block px-2 text-sm text-gray-700 hover:text-gray-900"
                                    role="menuitem"
                                  >
                                    Become a Rider
                                  </Link>
                                </div>
                                <div className="flex items-center px-2 py-2 hover:bg-[#0292EE1A] ">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="16"
                                    fill="none"
                                    // xmlns:v="https://vecta.io/nano"
                                  >
                                    <path
                                      d="M0 15.599c.084-.161.208-.213.37-.206l.758.003v-.228L1.13 4.31c0-.151-.026-.223-.163-.289-.42-.203-.658-.593-.674-1.104L.287.597C.29.283.496.049.77.008.829.001.888-.001.947.001H17.08c.359 0 .574.161.641.485.014.078.019.158.017.238l.003 1.92c.011.703-.235 1.208-.839 1.456v11.299l.844.007c.047.007.092.025.133.053s.075.066.102.11c.037.072.018.208-.018.292-.027.063-.117.097-.186.128a.35.35 0 0 1-.139.008H.393c-.163 0-.3-.034-.393-.201v-.197zm8.817-9.536l.16.19 4.069 4.624c.197.224.228.382.103.531s-.279.118-.48-.11L8.446 6.481c-.279-.323-.55-.488-.945-.438-.154.02-.206.05-.206.235l.004 7.278v.219h7.553l-1.127-1.282a.98.98 0 0 1-.137-.181c-.068-.13-.061-.28.049-.355.081-.055.204-.05.304-.037.053.007.101.085.146.137l1.419 1.611c.041.046.088.113.136.115l.715.005v-7.73l-7.539.003zm-2.063 9.322V6.07H3.359v9.315l3.396-.001zm7.341-11.68c-.721.57-1.053.571-1.699-.003-.564.58-1.135.57-1.697 0-.596.563-.982.563-1.7 0-.23.259-.503.421-.839.421s-.606-.169-.846-.433c-.24.276-.515.434-.851.432s-.607-.168-.844-.438c-.235.289-.514.438-.849.438s-.606-.169-.842-.435c-.238.282-.514.436-.85.435s-.606-.167-.817-.406l-.594.415v1.298h14.698V4.215l-.006-.08-.595-.417c-.484.545-1.167.555-1.668-.012v-.001zm2.265 10.702H7.314v.971h9.046v-.971zM2.809 6.07h-1.14v7.715h1.14V6.07zM4.204.607l.004 2.347c.003.217.121.384.293.49a.52.52 0 0 0 .286.084.52.52 0 0 0 .285-.089c.086-.058.158-.14.207-.239a.72.72 0 0 0 .074-.325L5.357.701a.48.48 0 0 0-.019-.093H4.204zm10.159 0l.005 2.35c0 .103.056.218.111.307.069.109.167.19.279.232a.5.5 0 0 0 .345.003.58.58 0 0 0 .305-.241c.075-.117.114-.258.111-.403V.718a.6.6 0 0 0-.02-.111h-1.136zm-3.38 0l.006 2.387a.57.57 0 0 0 .501.527c.375.037.643-.258.646-.725V.762a1.47 1.47 0 0 0-.015-.154h-1.137zM.837.607C.825.637.816.649.816.66v2.197a.74.74 0 0 0 .045.259c.03.082.074.156.13.218a.58.58 0 0 0 .195.143.52.52 0 0 0 .228.046c.326-.01.557-.296.558-.703V.763L1.958.607H.837zm6.744.005v.223 1.875c-.001.093.005.186.017.278.022.149.09.284.191.382s.229.152.362.153c.344.007.589-.273.593-.703V.726C8.741.688 8.736.649 8.728.612H7.581zM1.67 14.404v.976h1.14v-.976H1.67zM5.9 1.048c-.052.689-.052.689.344 1.138l.36.411.372.469.076-.041v-.408c-.004-.103.01-.241-.041-.301L5.9 1.048H5.9zm-3.398-.021l-.002.537c-.006.068.002.137.025.201s.058.12.104.165l.871.983c.038.044.08.083.121.123l.044-.017v-.53c0-.062-.007-.143-.041-.183l-1.122-1.28h.001zm14.649 2.013l.044-.024c-.009-.301.114-.612-.167-.881s-.534-.596-.799-.896l-.159-.173c-.088.463-.01.824.322 1.124.276.252.507.564.758.85h.001zM9.277 1.036l.004.693c.011.057.038.109.078.147l.967 1.099c.031.027.064.052.098.073l.016-.402c-.004-.114.007-.267-.051-.336L9.277 1.036zm3.386 0l-.002.54c-.006.069.003.138.026.202s.06.12.106.164l.76.861a2.92 2.92 0 0 1 .189.28l.06-.054a2.08 2.08 0 0 0 .022-.276c-.007-.151.02-.346-.052-.436l-1.11-1.28zM3.658.619h-.7l.7.796V.619zM6.341.612l.697.792V.61l-.697.003zm4.089.806V.618h-.707l.707.801zm3.387 0v-.8h-.704l.704.8zm2.694-.803l.687.779V.615h-.687zm.217 2.894l-.675-.776c-.033.535.26.871.676.771l-.001.005zM2.506 2.703c-.027.272.023.523.238.703.145.121.306.161.464.1l-.702-.803zm3.392.015c-.066.522.285.92.681.78l-.681-.78zm3.397-.046c-.044.342.029.577.221.733a.49.49 0 0 0 .248.117c.09.014.182 0 .266-.039l-.593-.659c-.038-.05-.08-.093-.14-.157l-.002.005zm3.377.055c-.044.538.273.896.677.775l-.675-.78-.002.005z"
                                      fill="#0dc1d9"
                                    />
                                  </svg>
                                  <Link
                                    to={`/restaurants`}
                                    className="block px-2 text-sm text-gray-700 hover:text-gray-900"
                                    role="menuitem"
                                  >
                                    Restaurant
                                  </Link>
                                </div>
                                <div className="flex items-center px-2 py-2 hover:bg-[#0292EE1A] ">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="16"
                                    fill="none"
                                    // xmlns:v="https://vecta.io/nano"
                                  >
                                    <path
                                      d="M0 3.383a2.86 2.86 0 0 1 .122-.264c.197-.337.509-.455.887-.455h3.55.229l.012-.193.016-1.093C4.863.631 5.446.063 6.198.012l.228-.01L11.576 0c.538 0 .986.168 1.319.597.228.293.307.631.304.993v1.076h3.742c.709 0 1.059.345 1.059 1.042v6.337c0 .406-.145.716-.517.914-.047.025-.079.119-.079.181l-.004 3.542v.417c-.015.514-.364.869-.88.899l-.175.003c-4.898 0-9.796-.002-14.694-.005-.209.002-.416-.041-.605-.129-.327-.163-.447-.47-.447-.826l.003-3.872c0-.124-.025-.196-.148-.254-.249-.115-.359-.348-.454-.587V3.383zm10.197 8c.079-.006.136-.008.193-.016l2.4-.328 4.208-.571c.322-.043.401-.124.401-.448v-6.32c0-.352-.09-.441-.446-.441H1.05c-.367 0-.451.086-.451.453v6.284c0 .046-.002.092 0 .139.01.163.089.272.257.306.057.012.115.019.174.027l6 .82.774.098c0-.172-.005-.316 0-.46.007-.219.098-.428.254-.584a.89.89 0 0 1 .587-.259 7.99 7.99 0 0 1 .668-.003.88.88 0 0 1 .883.892c.005.131.003.263.003.409v.002zm-8.999-.292v.186 3.715c0 .319.096.415.418.415h14.762c.332 0 .424-.094.424-.426v-3.891l-6.607.903c0 .277.008.538-.002.797a.87.87 0 0 1-.259.58.89.89 0 0 1-.588.255c-.193.008-.387.005-.58.003-.593-.004-.96-.367-.963-.956v-.682l-6.605-.898zm11.389-8.435V1.369a.46.46 0 0 0-.023-.118c-.121-.425-.451-.654-.956-.655H7.25c-.334 0-.668-.006-1.001.007-.406.016-.776.294-.815.685-.045.45-.011.907-.011 1.368h.579v-.178-.92c.002-.268.103-.368.372-.368h5.253c.267 0 .366.102.369.371v.92.176h.591zM6.61 2.653h4.777v-.857H6.61v.857zm2.989 9.202v-.867a.29.29 0 0 0-.318-.316c-.188-.005-.376-.006-.564 0a.29.29 0 0 0-.314.319v1.718c0 .21.116.32.327.326.164.005.328.002.492 0 .268-.002.376-.105.376-.366l.001-.815h0z"
                                      fill="#0dc1d9"
                                    />
                                  </svg>
                                  <Link
                                    to={`/`}
                                    className="block px-2 text-sm text-gray-700 hover:text-gray-900"
                                    role="menuitem"
                                  >
                                    BMP for work
                                  </Link>
                                </div>

                                

                                {/* <form method="POST" action="#" role="none">
                                  <button
                                    type="submit"
                                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900"
                                    role="menuitem"
                                  >
                                    Sign out
                                  </button>
                                </form> */}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </li>
                </OutsideClickHandler>
              ) : null}

              {!user?.id ? (
                <li className="md:block hidden">
                  <Link to={"/login"} className="flex items-center">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 16 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="7.50586" cy="7.5" r="7.5" fill="#0DC1D9
" />
                      <path
                        d="M8.9639 7.36192C9.29484 7.53613 9.65096 7.68516 9.96441 7.89646C11.2742 8.78014 11.9556 10.0213 12.006 11.6033C12.0144 11.8608 11.8731 12 11.6163 12C8.87574 12 6.1352 12 3.39536 12C3.14418 12 3.00565 11.8601 3.00635 11.6124C3.01545 9.75267 4.22235 8.05109 5.97288 7.42839C6.00646 7.41649 6.03935 7.4018 6.08203 7.38431C5.39637 6.84486 5.04584 6.1494 5.08922 5.28041C5.1221 4.62902 5.39007 4.07489 5.87423 3.6362C6.87753 2.72663 8.40628 2.8036 9.30183 3.79502C10.2289 4.82143 10.1442 6.46705 8.9639 7.36192ZM11.293 11.3024C11.1482 9.44412 9.50193 7.73134 7.30082 7.85378C5.08082 7.97762 3.79136 9.83384 3.73049 11.3024C6.24924 11.3024 8.7673 11.3024 11.293 11.3024ZM5.77628 5.41405C5.77348 6.36699 6.5452 7.14852 7.49393 7.15272C8.45175 7.15762 9.23537 6.38379 9.23816 5.43014C9.24096 4.4772 8.46925 3.69637 7.52052 3.69147C6.56199 3.68727 5.77908 4.4597 5.77628 5.41405Z"
                        fill="white"
                      />
                    </svg>
                    <span className="pl-2 text-black">Login</span>
                  </Link>
                </li>
              ) : (
                <OutsideClickHandler
                  onOutsideClick={() => {
                    setIsOpen2(false);
                  }}
                >
                  <li>
                    <div className="flex justify-center bg-gray-100 rounded-md">
                      <div>
                        <div
                          // @click.away="$refs.dropdown.removeAttribute('open');"
                          className="relative inline-block text-left"
                        >
                          <div className="list-none">
                            <div
                              onClick={() => setIsOpen2(!isOpen2)}
                              className="
                            inline-flex
                            justify-center
                            w-full
                            rounded-md
                            px-4
                            py-2
                            bg-white
                            text-sm
                            font-medium
                            text-gray-700
                            hover:bg-gray-50
                            focus:outline-none
                            focus:ring-2
                            focus:ring-offset-2
                            focus:ring-offset-gray-100
                            focus:ring-indigo-500
                            cursor-pointer items-center
                          "
                            >
                              {user?.profile_pic ? (
                                <img
                                  src={`${IMAGE_URL}${user.profile_pic}`}
                                  alt={"Profile Pic"}
                                  className=" h-8 w-8 mr-2  rounded-full"
                                />
                              ) : (
                                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.6886 0H12.3088C12.3736 0.0144127 12.4372 0.0342356 12.5026 0.0432436C12.8878 0.0948889 13.2772 0.120708 13.6571 0.196975C16.5055 0.769278 18.8415 2.19192 20.6134 4.49555C22.4735 6.91628 23.2338 9.6733 22.938 12.7078C22.7376 14.7598 22.0379 16.6466 20.7856 18.2861C18.0404 21.8784 14.3885 23.423 9.90497 22.9011C7.8048 22.6567 5.92426 21.8064 4.28313 20.4642C2.07136 18.656 0.692454 16.3488 0.180014 13.5341C0.106208 13.1311 0.0600046 12.7228 0 12.3168V10.6954C0.0330026 10.4372 0.0630048 10.1777 0.100208 9.92012C0.424833 7.69817 1.3003 5.71642 2.76741 4.01873C4.55675 1.94871 6.79853 0.655779 9.49753 0.175357C9.89176 0.106897 10.2908 0.0582512 10.6886 0ZM2.90362 17.2291C4.37334 15.1073 6.35529 13.6946 8.84948 12.9912C6.4541 11.2269 6.34909 8.02665 8.08682 6.10497C8.90695 5.20321 10.0508 4.66355 11.2677 4.60423C12.4847 4.54491 13.6755 4.97076 14.5793 5.78849C15.5394 6.65084 16.0506 7.7426 16.0908 9.03134C16.1418 10.6744 15.4554 11.9739 14.1431 12.9876C16.6549 13.6908 18.6248 15.1117 20.0974 17.2327C22.7682 13.3293 22.4891 7.47417 18.4052 3.80134C14.2409 0.0552514 7.95541 0.347706 4.13612 4.23372C0.26702 8.17498 0.508839 13.8656 2.90362 17.2291ZM3.63148 18.2098C7.7262 23.0855 15.3204 23.0452 19.3605 18.2098C17.5154 15.4246 14.9496 13.8554 11.5845 13.8259C8.15463 13.7989 5.53063 15.3633 3.63148 18.2098ZM11.4921 12.6501C12.4034 12.6528 13.2786 12.2942 13.9263 11.6527C14.5741 11.0112 14.9415 10.1391 14.9484 9.22711C14.9664 7.33485 13.4056 5.75967 11.5071 5.75546C10.5914 5.75705 9.71369 6.12157 9.06595 6.76928C8.4182 7.41698 8.0532 8.29511 8.05082 9.21149C8.0532 10.1233 8.41635 10.9971 9.06081 11.6416C9.70528 12.2861 10.5786 12.649 11.4897 12.6507L11.4921 12.6501Z" fill="#0DC1D9"/>
                                </svg>
                                
                              )}

                              {user?.user?.first_name
                                ? user?.user?.first_name
                                : "Account"}
                              {/* <!-- Heroicon name: solid/chevron-down --> */}
                              <svg
                                className="-mr-1 ml-2 h-5 w-5"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                aria-hidden="true"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            </div>
                          </div>

                          {isOpen2 ? (
                            <div
                              role="menu"
                              style={{ zIndex: "999" }}
                              className="
                          origin-top-right
                          absolute
                          right-0
                          mt-2
                          w-56
                          rounded-md
                          shadow-lg
                          bg-white
                          ring-1 ring-black ring-opacity-5
                          focus:outline-none
                        "
                            >
                              <div className="py-1" role="none">
                                {user?.user?.role === "ADMIN" ? (
                                  <Link
                                    to="/admin"
                                    className="
                              flex
                              px-4
                              py-2
                              text-sm text-gray-700
                              hover:bg-gray-100 hover:text-gray-90
                            "
                                    role="menuitem"
                                  >
                                    Admin Deshboard
                                  </Link>
                                ) : null}

                                {user?.user?.role === "VENDOR" ? (
                                  <Link
                                    to="/vendor"
                                    className="
                              flex
                              px-4
                              py-2
                              text-sm text-gray-700
                              hover:bg-gray-100 hover:text-gray-90
                            "
                                    role="menuitem"
                                  >
                                    Vendor Deshboard
                                  </Link>
                                ) : null}

                                <Link
                                  to="/profile"
                                  className="
                              flex
                              px-4
                              py-2
                              text-sm text-gray-700
                              hover:bg-gray-100 hover:text-gray-90
                            "
                                  role="menuitem"
                                >
                                  Profile
                                </Link>
                                <Link
                                  to={"/order"}
                                  className="flex
                              px-4
                              py-2
                              text-sm text-gray-700
                              hover:bg-gray-100 hover:text-gray-90"
                                >
                                  Order History
                                </Link>
                                <button
                                  className="
                              
                              flex
                              w-full
                              px-4
                              py-2
                              text-sm text-gray-700
                              hover:bg-gray-100 hover:text-gray-900
                            "
                                  role="menuitem"
                                  onClick={logout}
                                >
                                  Logout
                                </button>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </li>
                </OutsideClickHandler>
              )}
              {/* <li>
                <button type="button" className="mt-1">
                  <a href="#" role="button" className="relative flex">
                    <svg
                      width="14"
                      height="16"
                      viewBox="0 0 14 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.12536 15.9988C1.86391 15.923 1.58956 15.8758 1.34393 15.766C0.614116 15.4403 0.129518 14.9056 0.0196093 14.1017C-0.0128638 13.8632 0.0196084 13.6141 0.0408408 13.3711C0.119526 12.4537 0.204455 11.5371 0.290634 10.6201C0.370567 9.74447 0.453416 8.86926 0.532933 7.99364C0.60121 7.23726 0.666572 6.48046 0.7336 5.72367C0.79813 4.99843 0.860578 4.27277 0.930104 3.54753C0.957165 3.26522 1.14409 3.10911 1.44593 3.10706C1.9963 3.10337 2.54668 3.10706 3.09664 3.10706H3.29231C3.33519 2.13105 3.72154 1.32919 4.47425 0.716623C5.06501 0.236406 5.75277 0.0126868 6.52172 0.000394499C7.88517 -0.0237803 9.64413 1.06368 9.73239 3.10747H9.98218C10.5005 3.10747 11.0188 3.10747 11.5376 3.10747C11.8943 3.10747 12.0654 3.27956 12.0942 3.62661C12.1587 4.40512 12.2341 5.18076 12.3023 5.95804C12.3706 6.71975 12.4368 7.48146 12.5059 8.24317C12.575 9.00488 12.6458 9.76618 12.7141 10.5279C12.7715 11.1562 12.828 11.7831 12.8835 12.4086C12.9189 12.8077 12.9422 13.208 12.9893 13.6059C13.0875 14.4356 12.7449 15.0617 12.0817 15.5394C11.7508 15.776 11.3638 15.9248 10.9576 15.9717C10.9326 15.978 10.9085 15.9875 10.886 16L2.12536 15.9988ZM1.80146 4.00726C1.7926 4.03407 1.78564 4.06145 1.78065 4.08921C1.71459 4.81992 1.64895 5.55049 1.58373 6.28092C1.51628 7.04304 1.45134 7.80475 1.38265 8.56646C1.30313 9.44741 1.21986 10.3284 1.13951 11.2089C1.06707 12.0013 1.00421 12.795 0.922194 13.5854C0.87848 14.0029 0.950504 14.37 1.27107 14.6692C1.62744 15.0015 2.06208 15.1109 2.53627 15.1109C5.18185 15.1109 7.82744 15.1109 10.473 15.1109C10.7815 15.1109 11.0833 15.0699 11.3635 14.9285C11.8119 14.7056 12.1508 14.2815 12.0971 13.7403C12.0234 12.995 11.9651 12.248 11.8973 11.5019C11.7961 10.3931 11.6891 9.28474 11.5908 8.17557C11.4797 6.94634 11.3731 5.71711 11.2636 4.49117C11.249 4.32727 11.2286 4.16337 11.2116 4.0089H9.71657C9.71657 4.45388 9.7199 4.88534 9.71657 5.31721C9.71365 5.5946 9.52756 5.77858 9.26611 5.77694C9.00466 5.7753 8.82564 5.58805 8.82314 5.30983C8.81981 4.93 8.82314 4.54976 8.82314 4.16952V4.00562H4.18865C4.18865 4.45634 4.19115 4.89845 4.18865 5.34015C4.19012 5.45333 4.14634 5.56255 4.06675 5.64426C3.98716 5.72596 3.87813 5.77361 3.76317 5.77694C3.51088 5.78554 3.30855 5.61632 3.29939 5.3672C3.28773 5.05005 3.29398 4.73209 3.29273 4.41455C3.29273 4.28056 3.29273 4.14657 3.29273 4.0048L1.80146 4.00726ZM8.80607 3.09845C8.79733 1.89627 7.70823 0.7535 6.25152 0.904695C4.90889 1.0436 4.16367 2.23595 4.21696 3.09845H8.80607Z"
                        fill="#0DC1D9
"
                      />
                    </svg>
                    <span className="absolute right-0 top-0 rounded-full bg-red-600 w-4 h-4 top right p-0 m-0 text-white font-mono text-sm  leading-tight text-center">
                      5
                    </span>
                  </a>
                </button>
              </li> */}
              <li className="font-sans block mt-4 lg:inline-block lg:mt-0 lg:ml-6 align-middle text-black hover:text-gray-700">
                {cartItemsQuantity > 0 ? (
                  <Link
                    to={`/restaurant/${cart[0]?.res_id}`}
                    role="button"
                    className="relative flex"
                  >
                    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.58685 22.9982C3.1444 22.8893 2.6801 22.8215 2.26442 22.6637C1.02936 22.1954 0.209269 21.4268 0.023269 20.2711C-0.0316854 19.9283 0.0232676 19.5702 0.0591993 19.2209C0.192358 17.9022 0.336085 16.5846 0.481926 15.2664C0.617198 14.0077 0.757403 12.7496 0.891971 11.4909C1.00752 10.4036 1.11813 9.31567 1.23156 8.22778C1.34077 7.18524 1.44645 6.14211 1.56411 5.09958C1.6099 4.69375 1.92624 4.46934 2.43703 4.4664C3.36844 4.4611 4.29985 4.4664 5.23055 4.4664H5.56169C5.63425 3.06339 6.28807 1.91071 7.56189 1.03015C8.56164 0.339833 9.72554 0.0182372 11.0268 0.000567092C13.3342 -0.0341842 16.3109 1.52903 16.4603 4.46699H16.883C17.7602 4.46699 18.6373 4.46699 19.5152 4.46699C20.119 4.46699 20.4085 4.71437 20.4571 5.21325C20.5664 6.33236 20.6939 7.44735 20.8094 8.56469C20.925 9.65965 21.037 10.7546 21.1539 11.8496C21.2709 12.9445 21.3907 14.0389 21.5062 15.1338C21.6034 16.037 21.699 16.9382 21.793 17.8374C21.8529 18.4111 21.8923 18.9865 21.9719 19.5584C22.1382 20.7512 21.5584 21.6512 20.436 22.338C19.8761 22.6779 19.2211 22.8919 18.5337 22.9594C18.4914 22.9684 18.4506 22.982 18.4126 23L3.58685 22.9982ZM3.03872 5.76044C3.02371 5.79897 3.01194 5.83834 3.00349 5.87824C2.8917 6.92863 2.78062 7.97882 2.67024 9.02882C2.5561 10.1244 2.44619 11.2193 2.32994 12.3143C2.19538 13.5806 2.05447 14.847 1.91849 16.1128C1.7959 17.2519 1.68951 18.3928 1.55072 19.529C1.47674 20.1292 1.59863 20.6569 2.14113 21.0869C2.74422 21.5646 3.47976 21.7219 4.28224 21.7219C8.75938 21.7219 13.2365 21.7219 17.7137 21.7219C18.2357 21.7219 18.7465 21.663 19.2207 21.4598C19.9795 21.1393 20.553 20.5297 20.4621 19.7516C20.3374 18.6802 20.2387 17.6065 20.1239 16.5339C19.9527 14.9401 19.7716 13.3468 19.6054 11.7524C19.4172 9.98536 19.2369 8.21835 19.0516 6.45605C19.0269 6.22045 18.9924 5.98485 18.9635 5.76279H16.4335C16.4335 6.40245 16.4391 7.02267 16.4335 7.64348C16.4286 8.04224 16.1136 8.3067 15.6712 8.30435C15.2287 8.30199 14.9258 8.03282 14.9216 7.63288C14.9159 7.08688 14.9216 6.54028 14.9216 5.99368V5.75808H7.07857C7.07857 6.40599 7.0828 7.04152 7.07857 7.67647C7.08106 7.83917 7.00697 7.99617 6.87227 8.11362C6.73758 8.23107 6.55307 8.29957 6.35853 8.30435C5.93157 8.31672 5.58916 8.07346 5.57367 7.71534C5.55394 7.25945 5.56451 6.80239 5.56239 6.34591C5.56239 6.1533 5.56239 5.9607 5.56239 5.7569L3.03872 5.76044ZM14.8927 4.45403C14.8779 2.72589 13.0348 1.08316 10.5696 1.3005C8.29743 1.50017 7.0363 3.21417 7.12648 4.45403H14.8927Z" fill="#0DC1D9"/>
</svg>

                    <span className="absolute left-5 bottom-3 rounded-full bg-red-600 w-4 h-4 top right p-0 m-0 text-white font-mono text-sm  leading-tight text-center">
                      {cartItemsQuantity}
                    </span>
                  </Link>
                ) : (
                  ""
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
